import { render, staticRenderFns } from "./account_edit.vue?vue&type=template&id=770585cf&scoped=true&"
import script from "./account_edit.vue?vue&type=script&lang=ts&"
export * from "./account_edit.vue?vue&type=script&lang=ts&"
import style0 from "./account_edit.vue?vue&type=style&index=0&id=770585cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770585cf",
  null
  
)

export default component.exports